/**
 * @description 判断文件是否是图片类型
 * @param {String} type 文件类型
 */
export const getSuffixIsImageType = type => {
    return ['png', 'jpg', 'jpeg', 'gif'].includes(type);
};